import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import Utils from '@shared/utils/utils';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'dk-date-range',
  templateUrl: './dk-date-range.component.html',
  styleUrls: ['./dk-date-range.component.scss']
})
export class DkDateRangeComponent implements OnChanges {
  @Input() dateFrom: string;    // YYYY-MM-DD
  @Input() dateTo: string;      // YYYY-MM-DD
  @Output() dateChanged = new EventEmitter();

  ngbDateFrom: NgbDate | null;
  ngbDateTo: NgbDate | null;
  hoveredDate: NgbDate | null = null;

  constructor(
    private calendar: NgbCalendar,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    const momentToNgDate = (date: any) => {
      if (!date) {
        return null;
      }
      const m = moment(date);
      return new NgbDate(m.year(), m.month() + 1, m.date());
    }

    const isDiff = (date1: any, date2: any) => {
      if (date1 === null && date2 === null) {
        return false;
      }
      if (date1 === null || date2 === null) {
        return true;
      }
      return date1.equals(date2);
    }

    const { dateFrom, dateTo } = changes;
    if (dateFrom) {
      const date: NgbDate | null = momentToNgDate(dateFrom.currentValue);
      if (dateFrom.isFirstChange() || isDiff(date, this.ngbDateFrom)) {
        this.ngbDateFrom = date;
      }
    }
    if (dateTo) {
      const date: NgbDate | null = momentToNgDate(dateTo.currentValue);
      if (dateTo.isFirstChange() || isDiff(date, this.ngbDateTo)) {
        this.ngbDateTo = date;
      }
    }
  }

  isHovered(date: NgbDate) {
    return this.ngbDateFrom && !this.ngbDateTo && this.hoveredDate && date.after(this.ngbDateFrom) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.ngbDateTo && date.after(this.ngbDateFrom) && date.before(this.ngbDateTo);
  }

  isRange(date: NgbDate) {
    return date.equals(this.ngbDateFrom) || (this.ngbDateTo && date.equals(this.ngbDateTo)) || this.isInside(date) || this.isHovered(date);
  }

  formatNgDate(date: NgbDate | null | undefined) {
    if (!date) {
      return null;
    }

    return Utils.NgbDateToString(date, 'M/D/YYYY');
  }

  validateDateInput(field: string, input: string) {
    let parsed;
    try {
      const m = moment(input, 'MM/DD/YYYY');
      parsed = new NgbDate(m.year(), m.month() + 1, m.date());
    } catch (e) {
      parsed = null;
    }

    if (parsed && this.calendar.isValid(parsed)) {
      (this as any)[field] = parsed;
    } else {
      (this as any)[field] = null;
    }
    this.emitDateChanged();
  }

  onDateChanged(date: NgbDate) {
    if (!this.ngbDateFrom && !this.ngbDateTo) {
      this.ngbDateFrom = date;
    } else if (this.ngbDateFrom && !this.ngbDateTo && date && date.after(this.ngbDateFrom)) {
      this.ngbDateTo = date;
    } else {
      this.ngbDateTo = null;
      this.ngbDateFrom = date;
    }
    this.emitDateChanged();
  }

  emitDateChanged() {
    this.dateChanged.emit({
      dateFrom: Utils.NgbDateToString(this.ngbDateFrom),
      dateTo: Utils.NgbDateToString(this.ngbDateTo),
    })
  }
}
